<template>
  <b-container fluid class="main_container">
    <b-row><b-col class="top_bar" /> </b-row>
    <b-row
      ><b-col><div class="page_title">User Administration</div></b-col></b-row
    >
    <b-row>
      <b-col>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Students">
              <user-admin-tab
                @token-created="openSignupTokenModal"
                :config="students"
              />
            </b-tab>
            <b-tab title="Staff">
              <user-admin-tab
                @token-created="openSignupTokenModal"
                :config="staff"
              />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <signup-token-modal :signup-token="token" />
  </b-container>
</template>

<script>
import AccountRestService from "../../services/rest/services/AccountRestService";
import UserAdminTab from "../../components/UserAdministration/UserAdminTab";
import SignupTokenModal from "../../components/UserAdministration/SignupTokenModal";
export default {
  name: "UserAdministration",
  components: {
    UserAdminTab,
    SignupTokenModal
  },
  data: function() {
    return {
      students: null,
      staff: null,
      token: null
    };
  },
  mounted: function() {
    let $comp = this;
    return AccountRestService.getUsers()
      .then(response => {
        let data = response.data;
        $comp.students = {
          type: "student",
          data: data.students,
          fields: [
            { key: "avatar", sortable: true },
            { key: "last", sortable: true },
            { key: "first", sortable: true },
            { key: "email", sortable: true },
            { key: "phone", sortable: true }
          ]
        };
        $comp.staff = {
          type: "staff",
          data: data.staff,
          fields: [
            { key: "avatar", sortable: true },
            { key: "last", sortable: true },
            { key: "first", sortable: true },
            { key: "email", sortable: true },
            { key: "phone", sortable: true },
            { key: "access", sortable: true }
          ]
        };
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    openSignupTokenModal(token) {
      console.log(token);
      this.token = token;
      this.$bvModal.show("signupTokenModal");
    }
  }
};
</script>

<style scoped></style>
